<script>
    import { redirect } from "@roxi/routify";

    import { TokenStore } from "../../stores/TokenStore";

    import Simple from "./Simple.svelte";
    import LoadingMessage from "./LoadingMessage.svelte";
</script>

<!-- Fetching access token with refresh token -->
{#await TokenStore.init()}
    <Simple>
        <LoadingMessage>Checking permissions...</LoadingMessage>
    </Simple>

    <!-- Access token exists -->
{:then token}
    {#if !$TokenStore.expired}
        <slot></slot>

        <!-- No access token -->
    {:else}
        {$redirect(`/auth/login?redirectUrl=${window.location.pathname}`)}
    {/if}
{/await}
